import { TableContainer, Table } from '@mui/material';
import CreateTableHeader from './CreateTableHeader'
import CreateTableBody from './CreateTableBody';
import CreateNoRow from './CustomNoRowsOverlay';
import CustomPagination from './CustomPagination';

import { useEffect, useMemo, useState } from "react";
import { STTableColumnDetail } from '../STTableProps';
import React from 'react';

export default function CreateTable(props) {
     const [selectionModel, setSelectionModel] = useState([]);
     const [selectHead, setSelectHead] = useState(false);
     const [arrRowCollap, setarrRowCollap] = useState([]);
     let arrRow = props.rows ? props.rows.arrRows : [];

     const elCheckBox = {
          field: "elCheckbox_" + props.sTableID,
          headerName: "",
          bodyAlign: "center",
          sortable: true,
          collapse: false,
          isCheckBox: true,
          isSort: false,
          width: "40px"
     } as STTableColumnDetail;
     let arrColumn = [];
     if (props.isShowCheckBox && props.column) {
          arrColumn.push(elCheckBox);
     }
     arrColumn = arrColumn.concat(props.column);

     useMemo(() => {
          if (!selectHead) {
               setSelectionModel([]);
          }
          else {
               let arrTemp = [];
               arrRow.map((row, index) => {
                    if (!row.isDisable) {
                         arrTemp.push(row.sID);
                    }
               });
               setSelectionModel(arrTemp);
          }
     }, [selectHead]);

     useMemo(() => {
          if (props.isLoading) {
               setSelectionModel([]);
          }
     }, [props.isLoading]);

     useEffect(() => {
          let arrTemp = [];
          let arrStoreChildID = arrRow.filter(f => f.isCollapseHead);
          let arrStoreParentID = props.rows.arrRows.filter(item => item.isCollapseChild);
          let all = props.rows.arrRows;

          all.map((row, index) => {
               arrStoreChildID.map((childRow) => {
                    if (row.nID === childRow.nParentID) {
                         if (row.nParentID !== null) arrTemp.push(row.nParentID);
                    }
               });

               arrStoreParentID.map((item) => {
                    if (row.nParentID === item.nID) {
                         arrTemp.push(row.nParentID);
                    }
               });
          });

          setarrRowCollap([...new Set(arrTemp)]);
     }, [props.isLoading, arrRow]);

     return <TableContainer sx={{ maxWidth: "100%", overflowX: "unset" }}>
          <Table size='small' style={props.width ? { width: props.width } : { width: "100%", minWidth: "100%" }}>
               {CreateTableHeader(props, arrColumn, selectHead, setSelectHead)}
               {CreateTableBody(props, arrColumn, selectionModel, setSelectionModel, arrRowCollap, setarrRowCollap)}
          </Table>
          {
               arrRow.length === 0 ? <CreateNoRow /> : null
          }
          {
               arrRow.length === 0 || props.isPage === false ? null : <CustomPagination props={props} selectionModel={selectionModel} />
          }
     </TableContainer>
}